module.exports = __webpack_public_path__ + "media/images/product-img-03_1-5ce6c3f98bd72a295802519f48bbdc0e.png";